import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//import AOS from 'aos';
//import "aos/dist/aos.css";

import { BootstrapVue } from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
//import 'bootstrap-vue/dist/bootstrap-vue.css'

import './css/font.css'

import LoadScript from 'vue-plugin-load-script';
//import VueAnalytics from 'vue-analytics';


Vue.use(LoadScript);
Vue.config.productionTip = false
Vue.use(BootstrapVue)
/*
Vue.use(VueAnalytics, {
  id: 'UA-144536880-2',
  router
})
*/

new Vue({
  created(){
    /*
    AOS.init({
      offset: 100,
      delay: 200,
      duration: 1000,
      mirror: false,
      once: true,
      anchorPlacement: "top-center"
    });
    */
  },
  router,
  store,
  render: h => h(App)
}).$mount('#app')
